import { NavLink } from "react-router-dom";

const Item = ({ to, label, onClick }) => (
  <NavLink
    to={to}
    onClick={onClick}
    className={({ isActive }) =>
      `
      block rounded-xl px-4 py-3 text-sm font-medium transition
      ${
        isActive
          ? "bg-blue-600/15 text-blue-400 ring-1 ring-blue-600/20"
          : "text-slate-300 hover:bg-slate-800/60 hover:text-slate-100"
      }
    `
    }
  >
    {label}
  </NavLink>
);

export default function SidebarCliente({ open = true, onClose }) {
  return (
    <>
      {/* OVERLAY MOBILE */}
      {open && (
        <div
          onClick={onClose}
          className="fixed inset-0 z-40 bg-black/60 backdrop-blur-sm lg:hidden"
        />
      )}

      {/* SIDEBAR */}
      <aside
        className={`
          fixed inset-y-0 left-0 z-50 w-64
          bg-[#0b0f19] border-r border-[#1f2937]
          transform transition-transform duration-300
          ${open ? "translate-x-0" : "-translate-x-full"}
          lg:translate-x-0
        `}
      >
        <div className="flex h-full flex-col p-5">
          {/* TÍTULO */}
          <div className="mb-8">
            <p className="text-lg font-semibold text-slate-100">
              NGS Advogados
            </p>
            <p className="text-xs text-slate-400">Área do Cliente</p>
          </div>

          {/* MENU */}
          <nav className="flex flex-col gap-2 flex-1">
            <Item
              to="/app/cliente/dashboard"
              label="Início"
              onClick={onClose}
            />
            <Item
              to="/app/cliente/processos"
              label="Meus processos"
              onClick={onClose}
            />
            <Item
              to="/app/cliente/prazos"
              label="Minhas datas"
              onClick={onClose}
            />
          </nav>

          {/* SAIR */}
          <div className="pt-6 border-t border-[#1f2937]">
            <button
              onClick={() => {
                localStorage.removeItem("token");
                localStorage.removeItem("role");
                window.location.href = "/app/login";
              }}
              className="
                w-full rounded-xl px-4 py-3 text-sm font-medium
                text-slate-300 transition
                hover:bg-red-500/10 hover:text-red-400
              "
            >
              Sair
            </button>
          </div>
        </div>
      </aside>
    </>
  );
}
